(function () {
  'use strict';

  var STORAGE_KEY  = 'hoj_collection_scroll';
  var PRODUCT_SEL  = '.af-productGrid_item';
  var TIMEOUT_MS   = 10000;
  var POLL_MS      = 200;
  var RETRY_MS     = 3000;

  function log(msg, data) {
    if (data !== undefined) {
      // console.log('[HOJ-SCROLL] ' + msg, data);
    } else {
      // console.log('[HOJ-SCROLL] ' + msg);
    }
  }

  function isCollectionPath() {
    return window.location.pathname.indexOf('/collections/') !== -1;
  }

  function getProductCount() {
    return document.querySelectorAll(PRODUCT_SEL).length;
  }

  // ── Save state on product click ────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (!isCollectionPath()) return;
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;

    var productPath = '';
    try {
      productPath = new URL(link.href, window.location.origin).pathname;
    } catch (_) {
      productPath = link.getAttribute('href') || '';
    }

    var data = {
      scrollY:        Math.round(window.scrollY),
      collectionHref: window.location.href,
      productCount:   getProductCount(),
      productPath:    productPath,
      ts:             Date.now()
    };
    log('SAVE', data);
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (_) {}
  });

  // ── Restore on pageshow ────────────────────────────────────────────────────
  window.addEventListener('pageshow', function (e) {
    log('pageshow — persisted=' + e.persisted);

    if (!isCollectionPath()) return;

    var raw;
    try { raw = sessionStorage.getItem(STORAGE_KEY); } catch (_) { return; }
    if (!raw) { log('SKIP — no saved data'); return; }

    var saved;
    try { saved = JSON.parse(raw); } catch (_) { return; }

    if (!saved || saved.collectionHref !== window.location.href) {
      log('SKIP — URL mismatch', { saved: saved ? saved.collectionHref : null, current: window.location.href });
      return;
    }

    if (saved.ts && Date.now() - saved.ts > 1800000) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    sessionStorage.removeItem(STORAGE_KEY);

    var targetY     = saved.scrollY;
    var targetCount = saved.productCount || 0;
    var productPath = saved.productPath || '';
    if (!targetY && !productPath) return;

    var container = document.getElementById('ProductGridContainer');
    if (!container) { log('SKIP — container not found'); return; }

    log('STARTING — targetCount=' + targetCount + ', productPath=' + productPath);

    var lastCount       = 0;
    var triggered       = false;
    var lastTriggerTime = 0;

    function scrollToProduct() {
      var found = false;
      if (productPath) {
        var productLink = document.querySelector('a[href*="' + productPath + '"]');
        if (productLink) {
          var card = productLink.closest(PRODUCT_SEL) || productLink.closest('li') || productLink;
          log('FOUND product — scrolling to element');
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          found = true;
        }
      }
      if (!found) {
        log('Product not in DOM — fallback scrollY=' + targetY);
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }
    }

    function finish() {
      clearInterval(poll);
      clearTimeout(killTimer);
      log('FINISH — ' + getProductCount() + '/' + targetCount + ' products');
      setTimeout(scrollToProduct, 300);
    }

    var killTimer = setTimeout(function () {
      log('TIMEOUT — ' + getProductCount() + '/' + targetCount);
      clearInterval(poll);
    }, TIMEOUT_MS);

    var poll = setInterval(function () {
      var current = getProductCount();

      // ① Enough products → find product and scroll
      if (current >= targetCount) {
        log('READY — ' + current + '/' + targetCount);
        finish();
        return;
      }

      // ② New products appeared → allow next trigger
      if (current > lastCount) {
        log('LOADED — ' + current + '/' + targetCount);
        lastCount = current;
        triggered = false;
      }

      // ③ Trigger: scroll to bottom of collection section to load next page
      if (!triggered && current > 0) {
        var bottomY = 0;
        var rect = container.getBoundingClientRect();
        bottomY = Math.round(window.scrollY + rect.bottom);
        log('TRIGGER — scroll to container bottom (' + bottomY + ')');
        window.scrollTo(0, bottomY);
        triggered = true;
        lastTriggerTime = Date.now();
        return;
      }

      // ④ Retry if no new products for RETRY_MS
      if (triggered && Date.now() - lastTriggerTime > RETRY_MS) {
        log('RETRY');
        triggered = false;
      }
    }, POLL_MS);
  });
})();
